import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.5 16.5h-11v-4.559a2 2 0 0 1 1.368-1.897L4.5 9.5l3.5 3 3.5-3 .94.173m.06 6.827 3.5 3 3.5-3 1.633.544a2 2 0 0 1 1.367 1.898V23.5h-13v-4.558a2 2 0 0 1 1.367-1.898L12.5 16.5Zm7.5-5a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-8-7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
  stroke: "currentColor",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }